<template>
  <div :class="$style.mask">
    <div :class="$style.wrapper">
      <div :class="$style.backdrop" @click="$emit('backdrop')"></div>
      <slot name="container">
        <div :class="$style.container">
          <slot></slot>
        </div>
      </slot>
      <Button :class="$style.closeBtn" @click="$emit('close')">
        <SvgIcon :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/close.svg')" />
      </Button>
    </div>
  </div>
</template>

<script>
import Button from './Button'
import SvgIcon from './SvgIcon'

export default {
  components: {
    Button,
    SvgIcon,
  },
}
</script>

<style lang="scss" module>
.mask {
  @apply absolute;
  @apply inset-0;
  background-color: rgba(0,0,0,0.3);
  z-index: 1000;
}

.wrapper {
  @apply w-full;
  @apply h-full;
  @apply overflow-y-auto;
  @apply relative;
}

.backdrop {
  @apply absolute;
  @apply inset-0;
  z-index: 0;
}

.container {
  @apply mx-auto;
  @apply my-8;
  @apply p-8;
  @apply relative;
  width: 600px;
  background-color: white;
}

.closeBtn {
  @apply absolute;
  top: 0;
  right: 0;
  z-index: 100;
  @apply flex;
}
</style>
